import { ListSortDirection, Sort } from "../../models/api/sort";
import { LegalEntityAssetDTO, LegalEntityAssetSTO } from "../../models/legal-entity-assets";
import { BaseApiService } from "../base/base-api.service";

export class LegalEntityAssetsApiService extends BaseApiService<LegalEntityAssetDTO, LegalEntityAssetSTO> {
  constructor() {
    super({
      servicePath: "/LegalEntityAssets",
      loadItemsPath: "/GetLegalEntityAssets",
      saveItemsPath: "/SaveLegalEntityAssets",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
